import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { RestApiService } from '@draeger-academy/common';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { DependentFieldFilters, Field } from '../interfaces/hubspot-form-data';

@Injectable()
export class FormUtilsService {
    private _counter = 0;

    constructor(
        private _cookieService: CookieService,
        private _titleService: Title,
        private _restApi: RestApiService,
        private _translateService: TranslateService
    ) {}

    public getErrorTranslation(error: string, group: UntypedFormGroup, field: any, prefix = 'hubspot'): string {
        let _errorMessage = error;
        if (error === 'required') {
            this._translateService.get(prefix + '.required').subscribe((translation) => {
                _errorMessage = translation;
            });
            return _errorMessage;
        }
        const errorString = group.get(field.name).errors[error];
        if (errorString.messageKey) {
            this._translateService.get(prefix + '.' + errorString.messageKey.toLowerCase()).subscribe((translation) => {
                _errorMessage = translation;
            });
            return _errorMessage;
            // return this._translationService.getTranslation(prefix + '-' + errorString.messageKey.toLowerCase());
        }
        this._translateService.get(prefix + '.' + errorString.toLowerCase()).subscribe((translation) => {
            _errorMessage = translation;
        });
        return _errorMessage;
        // return this._translationService.getTranslation(prefix + '-' + errorString.toLowerCase());
        // return '_errorMessage;
    }

    public replaceMinMax(field: Field, errorTranslation: string) {
        const validationData = field.validation.data.split(':');
        if (validationData[0]) {
            errorTranslation = errorTranslation.replace('{{ min }}', validationData[0]);
        }
        if (validationData[1]) {
            errorTranslation = errorTranslation.replace('{{ max }}', validationData[1]);
        }
        return errorTranslation;
    }

    public isFieldInitiallyRequired(dependentField: DependentFieldFilters, initialDependentFields: string): boolean {
        const _initialDependentFields: any = JSON.parse(initialDependentFields);
        const _matchingDependentField = _initialDependentFields.filter(
            (f) => f.dependentFormField.name === dependentField.dependentFormField.name
        )[0];

        return _matchingDependentField ? _matchingDependentField.dependentFormField.required : false;
    }

    public getHubspotTrackingCookie() {
        return this._cookieService.get('hubspotutk') || '';
    }

    public getCurrentUrl() {
        return window.location.href;
    }

    public getCurrentPageName() {
        return this._titleService.getTitle();
    }

    public getIp(): Promise<string> {
        // TODO: WhatIsMyIP
        return this._restApi
            .requestGET<any>(environment.APIEndpoint + '/api/v1/HubSpot', {
                headers: new HttpHeaders(),
                responseType: 'text'
            })
            .then((res) => {
                let _result = res;
                if (res.body) {
                    _result = res.body;
                }
                _result = _result
                    .replace(/<[^>]*>?/gm, '')
                    .replace(/\s+/g, '')
                    .replace(/\"/g, '');
                return _result;
            });
    }
}
